import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns an object { [cat]: unread_count }. Refreshed every 45 s and
 * on window focus, so menu badges stay roughly in sync without being noisy.
 */
export default function useUnreadByCategory() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/notifications/unread-by-category`, { withCredentials: true });
        if (alive) setCounts(res.data?.counts || {});
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 45000);
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener('focus', onFocus); };
  }, []);

  return counts;
}
